import { ITEMS_BY_BREAKPOINTS as poster, templates as posterTemplates } from '../../../poster/poster.constants';
import { ITEMS_BY_BREAKPOINTS as portrait, templates as portraitTemplates } from '../../../portrait/portrait.constants';
import { ITEMS_BY_BREAKPOINTS as jacket, templates as jacketTemplates } from '../../../jacket/jacket.constants';
import { ITEMS_BY_BREAKPOINTS as card, templates as cardTemplates } from '../../../card/card.constants';
import { ITEMS_BY_BREAKPOINTS as totem, templates as totemTemplates } from '../../../totem/totem.constants';
import {
  ITEMS_BY_BREAKPOINTS as horizontalCard,
  templates as horizontalCardTemplates,
} from '../../../horizontal-card/horizontalCard.constants';
import {
  ITEMS_BY_BREAKPOINTS as horizontalSquare,
  templates as horizontalSquareTemplates,
} from '../../../horizontal-square/horizontalSquare.constants';

import {
  ITEMS_BY_BREAKPOINTS as flatRectangle,
  templates as flatRectangleTemplates,
} from '../../../flatRectangle/flatRectangle.constants';
import { ITEMS_BY_BREAKPOINTS as square, templates as squareTemplates } from '../../../square/square.constants';
import {
  ITEMS_BY_BREAKPOINTS as squareMeta,
  templates as squareMetaTemplates,
} from '../../../square-meta/squareMeta.constants';
import {
  ITEMS_BY_BREAKPOINTS as bigSquare,
  templates as bigSquareTemplates,
} from '../../../bigSquare/bigSquare.constants';

export const templates = {
  Grid: 'Grid',
};

export const MAX_PREVIEW_ITEMS = 4;

export const ITEMS_PER_ROW = {
  [cardTemplates.CardS]: card[cardTemplates.CardS],
  [cardTemplates.CardM]: card[cardTemplates.CardM],
  [cardTemplates.CardL]: card[cardTemplates.CardL],
  [horizontalCardTemplates.HorizontalCard]: horizontalCard,
  [horizontalSquareTemplates.HorizontalSquare]: horizontalSquare,
  [jacketTemplates.Jacket]: jacket,
  [posterTemplates.PosterS]: poster[posterTemplates.PosterS],
  [posterTemplates.PosterM]: poster[posterTemplates.PosterM],
  [posterTemplates.PosterL]: poster[posterTemplates.PosterL],
  [portraitTemplates.Portrait]: portrait,
  [totemTemplates.Totem]: totem,
  [flatRectangleTemplates.FlatRectangle]: flatRectangle,
  [squareTemplates.Square]: square,
  [squareMetaTemplates.SquareMeta]: squareMeta,
  [bigSquareTemplates.BigSquare]: bigSquare,
};
